/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaypalIntent } from './PaypalIntent';
import {
    PaypalIntentFromJSON,
    PaypalIntentFromJSONTyped,
    PaypalIntentToJSON,
} from './PaypalIntent';
import type { PaypalPaymentProcessor } from './PaypalPaymentProcessor';
import {
    PaypalPaymentProcessorFromJSON,
    PaypalPaymentProcessorFromJSONTyped,
    PaypalPaymentProcessorToJSON,
} from './PaypalPaymentProcessor';

/**
 * 
 * @export
 * @interface PaypalRequest
 */
export interface PaypalRequest {
    /**
     * 
     * @type {PaypalIntent}
     * @memberof PaypalRequest
     */
    intent?: PaypalIntent;
    /**
     * 
     * @type {string}
     * @memberof PaypalRequest
     */
    orderId?: string;
    /**
     * 
     * @type {PaypalPaymentProcessor}
     * @memberof PaypalRequest
     */
    paymentProcessor?: PaypalPaymentProcessor;
    /**
     * 
     * @type {string}
     * @memberof PaypalRequest
     */
    successUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalRequest
     */
    cancelUrl?: string;
}

/**
 * Check if a given object implements the PaypalRequest interface.
 */
export function instanceOfPaypalRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaypalRequestFromJSON(json: any): PaypalRequest {
    return PaypalRequestFromJSONTyped(json, false);
}

export function PaypalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intent': !exists(json, 'intent') ? undefined : PaypalIntentFromJSON(json['intent']),
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'paymentProcessor': !exists(json, 'paymentProcessor') ? undefined : PaypalPaymentProcessorFromJSON(json['paymentProcessor']),
        'successUrl': !exists(json, 'successUrl') ? undefined : json['successUrl'],
        'cancelUrl': !exists(json, 'cancelUrl') ? undefined : json['cancelUrl'],
    };
}

export function PaypalRequestToJSON(value?: PaypalRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intent': PaypalIntentToJSON(value.intent),
        'orderId': value.orderId,
        'paymentProcessor': PaypalPaymentProcessorToJSON(value.paymentProcessor),
        'successUrl': value.successUrl,
        'cancelUrl': value.cancelUrl,
    };
}

